module.exports = __webpack_public_path__ + "01_bob_black.f7c0a110.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/01_bob_black.png
// module id = vF8T
// module chunks = 0